// 交易看板圖表組件
export default {
  // 標題
  trendTitle: "轉入/轉出趨勢",

  // 數量統計
  transferInAmount: "轉入數量：",
  transferOutAmount: "轉出數量：",
  tenThousand: "萬",

  // 時間段選項
  currentWeek: "本週",
  currentMonth: "本月",
  halfYear: "半年",
  currentYear: "全年",

  // 日期選擇器
  startDate: "開始日期",
  endDate: "結束日期",

  // 圖表配置
  unit: "單位:(萬)",
  transferInSeries: "轉入數量",
  transferOutSeries: "轉出數量",
};
